var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"h-100"},[_c('v-main',{staticClass:"h-100"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }